import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MessageCircle, RefreshCw } from 'lucide-react';

const TABS = [
  { path: '/admin/whatsapp', label: 'Overview', end: true },
  { path: '/admin/whatsapp/logs', label: 'Logs' },
  { path: '/admin/whatsapp/simulator', label: 'Simulator' },
  { path: '/admin/whatsapp/agents', label: 'Sandbox' },
  { path: '/admin/whatsapp/blocklist', label: 'Blocklist' },
];

export default function WaAdminShell({
  title = 'WhatsApp Bot',
  subtitle = 'Operations console',
  lastUpdated,
  loading,
  onRefresh,
  children,
}) {
  const location = useLocation();

  const isActive = (tab) => {
    if (tab.end) {
      return location.pathname === tab.path || location.pathname === `${tab.path}/`;
    }
    return location.pathname.startsWith(tab.path);
  };

  return (
    <div className="p-4 lg:p-8 max-w-7xl mx-auto">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-[#659A9B]/15 flex items-center justify-center">
            <MessageCircle className="w-5 h-5 text-[#659A9B]" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-[#1B375B]">{title}</h1>
            <p className="text-sm text-gray-500">{subtitle}</p>
            {lastUpdated && (
              <p className="text-xs text-gray-400 mt-0.5">Updated {lastUpdated}</p>
            )}
          </div>
        </div>
        {onRefresh && (
          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex items-center gap-2 px-3 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            Refresh
          </button>
        )}
      </div>

      <nav className="flex flex-wrap gap-1 mb-6 border-b border-gray-200 pb-px">
        {TABS.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg border-b-2 -mb-px transition-colors ${
              isActive(tab)
                ? 'border-[#659A9B] text-[#1B375B] bg-white'
                : 'border-transparent text-gray-500 hover:text-[#1B375B]'
            }`}
          >
            {tab.label}
          </Link>
        ))}
      </nav>

      {children}
    </div>
  );
}
